import {
  ModalSheet,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import styles from './DeleteJobDialog.module.css'
import { byDesign } from '@/infra/design'
import imgMissingPermissionsUrl from '@/assets/misc/img_missing-permissions.svg'
import JobNoLongerAvailableIllustration from '@/components/SpotIllustration/JobNoLongerAvailableIllustration'

export interface DeleteJobDialogProps {
  showing: boolean
  isDeletePending: boolean
  onClose: () => unknown
  onDelete: () => unknown
}

export function DeleteJobDialog({
  showing,
  isDeletePending,
  onClose,
  onDelete,
}: DeleteJobDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isDeletePending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <div className={styles.contentBlock}>
          <ModalSheetContentIllustration
            src={imgMissingPermissionsUrl}
            illustration={byDesign(undefined, JobNoLongerAvailableIllustration)}
            alt="Illustration of hand holding a STOP symbol"
          />
          <ModalSheetContentTitle compact>
            Do you really want to delete this job?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription compact>
            Documents within this job will be deleted if they are not linked
            anywhere else. I hope you know what you're doing.
          </ModalSheetContentDescription>
        </div>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            variant="default"
            isDisabled={isDeletePending}
            onPress={onClose}
          />
          <Button
            label="Delete Forever"
            variant="destructive"
            isPending={isDeletePending}
            testId="delete-job-as-admin-submit-button"
            onPress={onDelete}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
